module.exports = __webpack_public_path__ + "img/update-list.eb7fa07b.png";